import React from 'react';
import {useSelector} from "react-redux";
import Vietnamese from "../features/TermsOfUse/vietnamese";
import English from "../features/TermsOfUse/english";
import Header from "../components/Header";
import Footer from "../components/Footer";
import LANGUAGE_CONFIG from "../config/constants/language"

function TermsOfUse() {
  const lang = useSelector(state => state.language.lang);
  const renderContent = () => {
    switch (lang) {
      case LANGUAGE_CONFIG.VN:
        return <Vietnamese />;
      case LANGUAGE_CONFIG.EN:
        return <English />
      case LANGUAGE_CONFIG.ESP:
        return <English />
      default:
        return <English />
    }
  }
  return (
    <article id='wrapper'>
      <Header />
      <div id='wrap'>
        {renderContent()}
      </div>
      <Footer />
    </article>
  )
}

export default TermsOfUse;